import React from 'react';
import { Box } from '@mui/material';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import TimeLineItem from './TimeLineItem';

const TimeLine = (props) => {
  return (
    <Box sx={{ width: 300 }} role="presentation">
      <TimeLineItem
        finalTimelogIndex={props.finalTimelogIndex}
        employeeId={props.employeeId}
        TimeLineItemThings={props.TimeLineItemThings}
        selectedDate={props.selectedDate}
        rawTimeData={props.rawTimeData}
      />
    </Box>
  );
};
export default TimeLine;
